import { InjectionToken } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { mainLayoutReducer } from '../layout/main/reducer'
import { CirtState } from './cirt.states';

export const featureKey = 'cirt';

export const reducers = new InjectionToken<ActionReducerMap<CirtState>>(featureKey, {
  factory: () => ({
    mainLayout: mainLayoutReducer
  })
});
